import { useState } from 'react'
import { TextField, Grid, MenuItem } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import Confirm from 'components/Dialog'
import { deletePhone } from 'store/member/personal'
import { useMember } from 'components/Providers'
import { useParams } from 'react-router-dom'
import PhoneField from 'components/PhoneField'

export default function PhoneEditForm({ path, control, item, index, ...props }) {
  const { employmentType, memberId } = useParams()
  const member = useMember()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  async function remove(id, index, confirmed = false) {
    try {
      if (!id) {
        props.remove(index)
        return
      }
      if (!confirmed) {
        setOpen(true)
        return
      }
      setOpen(false)
      const res = await dispatch(deletePhone({ type: employmentType, memberId, personId: member.person?.id, id }))
      if (res.error) {
        console.error(res)
        throw new Error('Error')
      }
      props.remove(index)
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Grid item xs={12} md={12} key={item?.id}>
      <Grid container spacing={2}>
        <Controller name={`${path}.${index}.id`} control={control} render={() => {}} />
        <Grid item xs={4} md={4}>
          <Controller
            name={`${path}.${index}.type`}
            control={control}
            render={({ field, fieldState }) => {
              return (
                <TextField
                  fullWidth
                  select
                  size="small"
                  label={t('Phone')}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  {...field}
                >
                  <MenuItem value="mobile">{t('Mobile')}</MenuItem>
                  <MenuItem value="home">{t('Home')}</MenuItem>
                  <MenuItem value="work">{t('Work')}</MenuItem>
                </TextField>
              )
            }}
          />
        </Grid>
        <Grid item xs={8} md={8}>
          <PhoneField name={`${path}.${index}.number`} control={control} label={t('Number')} size="small" />
        </Grid>
      </Grid>
      <Confirm open={open} onClose={() => setOpen(false)} onConfirm={() => remove(item.id, index, true)} />
    </Grid>
  )
}
